<script setup>
import { keyBy } from 'lodash-es';
import { useCommonImports } from '~/common/composables/common-imports.composable.js';

const props = defineProps({
  recent: {
    type: Array,
    default: () => [],
  },
  allSchemas: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['selected']);

const { $t } = useCommonImports();

const all_schemas_map = keyBy(props.allSchemas, 'name');
const search = ref('');

const table_columns = [
  {
    accessorKey: 'label',
    header: $t('Dataset name'),
    id: 'label',
  },
  {
    accessorKey: 'columns',
    header: $t('Columns'),
    id: 'columns',
  },
];

function getColumns(item) {
  if (item.generateSeries) {
    if (item.generateSeries.type === 'date') {
      return [
        {
          label: 'date',
          name: 'date',
          type: 'date',
        },
      ];
    }
    else {
      return [
        {
          label: 'number',
          name: 'number',
          type: 'integer',
        },
      ];
    }
  }
  else {
    return [];
  }
}

const recent_data = props.recent.map(item => (item.type === 'Data source'
  ? {
      label: item.alias,
      ...(all_schemas_map[item.name] || {}),
      type: item.type,
    }
  : { ...item, label: item.alias, columns: getColumns(item) }));

const filtered_data = recent_data.filter(item => item.name);

const searched_filtered_data = computed(() => filtered_data.filter(item => item.label.toLowerCase().includes(search.value.toLowerCase())));
</script>

<template>
  <div class="flex justify-start ml-8 mb-4">
    <hawk-search-input v-model="search" :placeholder="$t('Search')" class="my-[1px]" />
  </div>
  <hawk-table
    :columns="table_columns" :data="searched_filtered_data" class="w-full min-h-[600px]" :show_menu_header="false"
    @row-clicked="row => emit('selected', row)"
  >
    <template #label="row">
      <div>
        <hawk-breadcrumbs v-if="row.data.row.original.path" :items="row.data.row.original.path.map(path => ({ uid: path, label: path, truncate_length: 500 }))" :show_active_color="false" text_classes="!text-xs" />
        <div>
          {{ row.data.row.original.label }}
        </div>
      </div>
    </template>
    <template #columns="row">
      <div class="flex flex-wrap gap-2">
        <hawk-badge-group v-if="row.data.row.original?.columns" :items="row.data.row.original?.columns.map(col => ({ uid: col.label, label: col.label }))" color="gray" custom_classes="pointer-events-all" :max_badges_to_display="10" class="mr-2" @click="row => emit('selected', row)" />
      </div>
    </template>
  </hawk-table>
</template>
